module.exports = __webpack_public_path__ + "static/img/buy_daoju_active.e1163d64.png";